import { Injectable } from '@angular/core';

export interface DriverPortalSession {
  token: string;
  driverId: string;
  user: any;
}

const SESSION_KEY = 'polivias-driver-portal-session';

@Injectable({ providedIn: 'root' })
export class DriverPortalSessionService {
  private session: DriverPortalSession | null = this.read();

  get current(): DriverPortalSession | null { return this.session; }
  get isAuthenticated(): boolean { return !!this.session && !this.isExpired(this.session.token); }

  start(response: any): void {
    const token = response.token || response.accessToken || response.jwt;
    const user = response.user || response.userApp || response.driver || response;
    const driverId = user.id || user.idUserApp || response.driverId || response.idUserApp;
    if (!token || !driverId) { throw new Error('Resposta de autenticação incompleta.'); }
    this.session = { token, driverId, user };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(this.session));
  }

  clear(): void {
    this.session = null;
    sessionStorage.removeItem(SESSION_KEY);
  }

  private read(): DriverPortalSession | null {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null'); } catch (_) { return null; }
  }

  private isExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return !!payload.exp && Date.now() >= payload.exp * 1000;
    } catch (_) { return false; }
  }
}
